import React, { FC, useEffect, useState } from "react";
import {
  AEAStepper,
  AEAStep,
  BasicDataSubProFFRR,
  HeaderInformation,
  ImplementersFFRR,
  ZonaADTFFRR,
  ConsolidatedIntermediateResults,
  ObjetiveFE,
  CounterpartsFFRR
} from "@/components/";
import { Container } from "reactstrap";
import { Utilities } from "@utils";
import { IFormProa } from "@interfaces/screens/form-proa.interface";
import { Row } from "reactstrap";
import { MainProaSubprojectFFRRPresenter } from "../../../../../presenters/screens/form-proa-ffrr.presenter";

const FormProaSubproject: FC<any> = (props: { dataColumns: any; }) => {

  const [endDate, setEndDate] = useState(null);
  const [headerInfo, setHeaderInfo] = useState(null);
  const [readOnly, setReadOnly] = useState(false);
  const [switchForm, setSwitchForm] = useState(false);

  const [step1, setStep1] = useState<any>();
  const [step2, setStep2] = useState<any>();
  const [step3, setStep3] = useState<any>();
  const [stepSDC, setStepSDC] = useState<any>();
  const [step4, setStep4] = useState<any>();
  const [step4MRI, setStep4MRI] = useState<any>();

  const view: IFormProa = {
    state: {
      endDate: endDate,
      readOnly: readOnly,
      dataColumns: props.dataColumns,
      step1: step1,
      setHeaderInfo: setHeaderInfo,
      setReadOnly: setReadOnly,
    },
    step1Data: step1,
    step2Data: step2,
    stepSDCData: stepSDC,
    step3Data: step3,
    step4MRIData: step4MRI,
    step4Data: step4,
    setStep1: setStep1
  };
  const presenter = new MainProaSubprojectFFRRPresenter(view);

  const handleSwitch = () => {
    presenter.unSetLoading()
    setSwitchForm(switchForm => !switchForm) 
  }

  useEffect(() => {
    presenter.initializeHeaderInformation();
  }, [presenter.currentBudget, presenter.currentLabels, presenter.formMasters]);

  useEffect(() => {
    if (step1?.genericInfo)
      setEndDate(step1?.genericInfo?.OCTAVIAFechaFinalizacion)
  }, [step1?.genericInfo])

  let alertEndDate = presenter.validEndDate()

  const getStep1 = () => {
    return (
      <AEAStep title={presenter.currentLabels.get("Datos básicos")}>
        <BasicDataSubProFFRR
          alertEndDate={alertEndDate}
          step1={step1}
          endDate={endDate}
          dataColumns={props.dataColumns}
          files={step1?.files}
          headerInfo={headerInfo}
          switchForm={switchForm}
          handleSwitch={handleSwitch}
          setEndDate={setEndDate}
          setStep1={setStep1}
        ></BasicDataSubProFFRR>
      </AEAStep> 
    );
  };

  const getStep2 = () => {
    return (
      <AEAStep title={presenter.currentLabels.get("Implementadores")}>
        <ImplementersFFRR
          alertEndDate={alertEndDate}
          step1={step1}
          step2={step2}
          endDate={endDate}
          dataColumns={props.dataColumns}
          switchForm={switchForm}
          handleSwitch={handleSwitch}
          setStep2={setStep2}
          getWarningMsg={getWarningMsg}
        ></ImplementersFFRR>
      </AEAStep>
    );
  };

  const getStepSDC = () => {
    return (
      <AEAStep title={presenter.currentLabels.get("PProaContrapartidas")}>
        <CounterpartsFFRR
          alertEndDate={alertEndDate}
          step1={step1}
          step2={step2}
          stepSDC={stepSDC}
          endDate={endDate}
          dataColumns={props.dataColumns}
          switchForm={switchForm}
          handleSwitch={handleSwitch}
          setStepSDC={setStepSDC}
          getWarningMsg={getWarningMsg}
        ></CounterpartsFFRR>
      </AEAStep>
    );
  };

  const getStep3 = () => {
    return (
      <AEAStep title={presenter.currentLabels.get("ZONACCAA")}>
        <ZonaADTFFRR
          alertEndDate={alertEndDate}
          step1={step1}
          step3={step3}
          switchForm={switchForm}
          dataColumns={props.dataColumns}
          endDate={endDate}
          setStep3={setStep3}
          handleSwitch={handleSwitch}
          getWarningMsg={getWarningMsg}
        ></ZonaADTFFRR>
      </AEAStep>
    );
  };

  const getStep4 = () => {
    return (
      <AEAStep title={presenter.currentLabels.get("proaResultadosIntermedios")} >
        <ObjetiveFE
          alertEndDate={alertEndDate}
          index={-1}
          step1={step1}
          step4={step4}
          step4MRI={step4MRI}
          switchForm={switchForm}
          startDate={step1?.genericInfo?.OCTAVIAFechaInicio || null}
          endDate={endDate}
          dataColumns={props.dataColumns}
          subventionCodeId={null}
          getWarningMsg={getWarningMsg}
          setStep4={setStep4}
          setStep4MRI={setStep4MRI}
          handleSwitch={handleSwitch}
        ></ObjetiveFE>
      </AEAStep>
    );
  };

  const getStep5 = () => {
    return (
      <AEAStep title={presenter.currentLabels.get("proaFFRRConsolidadoResultadosIntermedios")} >
        <ConsolidatedIntermediateResults
          step1={step1}
          step2={step2}
          step3={step3}
          step4={step4}
          stepSDC={stepSDC}
          switchForm={switchForm}
          locations={step3?.zones}
          dataMasters={presenter.formMasters}
          labels={presenter.currentLabels}
          dataColumns={props.dataColumns}
          getWarningMsg={getWarningMsg}
        ></ConsolidatedIntermediateResults>
      </AEAStep>
    );
  };

  const getWarningMsg = () => {
    return <h5>{presenter.currentLabels.get("StepBlockMsg")}</h5>;
  };

  const renderFFRRform = () => {
    if (!Utilities.isNullEmptyObject(props.dataColumns)) {
      return (
        <Row>
          <HeaderInformation data={headerInfo}></HeaderInformation>
          <AEAStepper
            activeAll={false}
            defaultStep={presenter.currentLabels.get("Datos básicos")}
            activateValidation={false}
            errorSelectors={[".dx-invalid"]}
          >
            {getStep1()}
            {getStep2()}
            {getStepSDC()}
            {getStep3()}
            {getStep4()}
            {getStep5()}
          </AEAStepper>
        </Row>
      );
    } else {
      return <div></div>;
    }
  };
  return <Container fluid={true}>{renderFFRRform()}</Container>;
};
export default FormProaSubproject;
